import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/atbCarouselsPDP/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showAtbCarouselsPDPSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showAtbCarouselsPDPSelector };
